module.exports = __webpack_public_path__ + "21c2a2b222caf2f8ffcf4ea11c615baf.png";